import type { EExportRenderingMode } from '@/application/ports/EExportRenderingMode';
import type { I2DExporter } from '@/application/ports/I2DExporter';

class ExportsController {
    constructor(private readonly _exporter: I2DExporter) {}

    exportThumbnail(params: { mode?: EExportRenderingMode; width: number }): Promise<Blob | undefined> {
        return this._exporter.exportThumbnail(params);
    }

    exportPreviewZoneCanvas(): Promise<{ canvas: HTMLCanvasElement; hasOpaqueBackground: boolean }> {
        return this._exporter.exportPreviewZoneCanvas();
    }

    exportPrintBlob(): Promise<Blob | null> {
        return this._exporter.exportPrintBlob();
    }

    exportWatermarkedPreview(): Promise<Blob | undefined> {
        return this._exporter.exportWatermarkedPreview();
    }
}

export { ExportsController };
